module.exports = __webpack_public_path__ + "static/media/Jeffrey_Park.da51fb65.png";